module.exports = __webpack_public_path__ + "static/media/step-small-blank.e325bba5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/step-small-blank.svg
// module id = 856
// module chunks = 21